// Validate and sanitize hostname
export const validateAndSanitizeHostname = hostname => {
  if (!hostname) {
    throw new Error('Hostname is required');
  }

  // Remove leading/trailing whitespace
  const trimmed = String(hostname).trim();

  if (trimmed.length === 0) {
    throw new Error('Hostname cannot be empty');
  }

  // Validate hostname format - allow alphanumeric, hyphens, dots, and underscores
  // Must start and end with alphanumeric
  const hostnameRegex = /^[a-zA-Z0-9]([a-zA-Z0-9\-_.]*[a-zA-Z0-9])?$/;

  if (!hostnameRegex.test(trimmed)) {
    throw new Error(
      'Invalid hostname format. Hostname must contain only alphanumeric characters, hyphens, dots, and underscores, and must start and end with alphanumeric characters.'
    );
  }

  // Max length check (typical hostname limit is 255 characters)
  if (trimmed.length > 255) {
    throw new Error('Hostname exceeds maximum length of 255 characters');
  }

  return trimmed;
};
